import moment from 'moment-timezone';


export const getRealTimezoneMoment = (time: string, timezone: string) => {
  if (time && timezone) {
    // the logic below is due to the fact that the BE sends us some pretty weird timestamps. From Search service it gives us the local time BUT with a UTC marker on the end (the Z)
    // from the LoadService however it gives us the actual UTC time w/o a the UTC marker on the end. As this function is called from both spots we need to be able to handle either case
    // So for the same load we'll get "2021-03-14T18:58:00" from LoadService and "2021-03-14T14:58:00Z" from SearchService. The real pickup time in this example is March 14 at 14:58 CST
    if (time[time.length - 1] === 'Z') {
      return moment.tz(time.slice(0, -1), timezone);
    }
    return moment.utc(time).tz(timezone);
  }
  return moment.invalid();
}
